import script from "./DiseaseAnalyzer.vue?vue&type=script&setup=true&lang=js"
export * from "./DiseaseAnalyzer.vue?vue&type=script&setup=true&lang=js"

import "./DiseaseAnalyzer.vue?vue&type=style&index=0&id=b9d4bc1e&lang=css"

const __exports__ = script;

export default __exports__